import {
	JobProgress,
	JobQueue,
	SystemType,
	TilingJobPayload,
	TilingStoreState,
} from '@Types/tiling.types';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const systemTypes = Object.values(SystemType);
const initialJobs = systemTypes.reduce((acc, systemType) => {
	acc[systemType] = {};
	return acc;
}, {} as TilingStoreState['jobs']);
const initialQueues = systemTypes.reduce((acc, systemType) => {
	acc[systemType] = JobQueue.FREE;
	return acc;
}, {} as TilingStoreState['queues']);

export const initialState: TilingStoreState = {
	jobs: initialJobs,
	queues: initialQueues,
};

const tilingSlice = createSlice({
	name: 'tiling',
	initialState,
	reducers: {
		queueJob(state, action: PayloadAction<TilingJobPayload>) {
			const { systemType } = action.payload;
			// don't queue job if currently blocked
			if (state.queues[systemType] === JobQueue.BLOCKED) return;

			state.jobs[systemType] = {
				progress: JobProgress.QUEUED,
				lastRun: new Date(),
			};
		},
		queueJobSending(state, action: PayloadAction<TilingJobPayload>) {
			const { systemType } = action.payload;
			state.jobs[systemType].progress = JobProgress.SENDING;
			state.queues[systemType] = JobQueue.BLOCKED;
		},
		queueJobSuccess(state, action: PayloadAction<TilingJobPayload>) {
			const { systemType } = action.payload;
			state.jobs[systemType].progress = JobProgress.SUCCESS;
		},
		queueJobFailed(state, action: PayloadAction<TilingJobPayload>) {
			const { systemType } = action.payload;
			state.jobs[systemType].progress = JobProgress.FAILED;
			state.queues[systemType] = JobQueue.FREE;
		},
		queueFreed(state, action: PayloadAction<TilingJobPayload>) {
			const { systemType } = action.payload;
			state.queues[systemType] = JobQueue.FREE;
		},
	},
});

const { actions, reducer } = tilingSlice;

export default reducer;

export { actions };
export const { queueJob, queueJobSending, queueJobSuccess, queueJobFailed } =
	actions;
